import React, { useState, useEffect } from 'react';
import { toastr } from 'react-redux-toastr'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Grid, Button, Typography, Box } from '@material-ui/core';
import axios from 'axios';

import { URL } from '../../assets/js/constants'
import { getNegocio } from '../../store/actions/negocio';
import TituloPagina from '../../components/layout/TituloPagina';
import LoadingOverlay from '../../components/layout/LoadingOverlay';

const RegerarUrlStripe = props => {

    const { negocioDoUsuario, negocio, getNegocio } = props;
    // Estado que controla a visibilidade do loading
    const [isProcessing, setIsProcessing] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [urlStripe, setUrlStripe] = useState('');

    useEffect(() => {
        getNegocio(negocioDoUsuario);
    }, [negocioDoUsuario]);

    const handleGerarUrlOnboardStripe = async () => {
        // 1. Ativa o loading ANTES de iniciar a chamada à API
        setLoadingMessage('Comunicando com Stripe...');
        setIsProcessing(true);
        try {
            // 2. Faz a chamada ao backend Spring Boot
            const response = await axios.get(`${URL}/payment/v1/onboarding-stripe-redirect/${negocioDoUsuario}`);

            if (response.data) {
                const { urlStripe } = response.data;
                setUrlStripe(urlStripe);
                toastr.success('Sucesso!', 'Uma nova URL foi criada.');
            }

        } catch (error) {
            // Tratamento de erro
            toastr.error('Erro', 'Falha ao gerar o link de onboarding da Stripe. Verifique os dados.');
        } finally {
            // 3. Desativa o loading SEMPRE, independente de sucesso ou erro, no bloco finally
            setIsProcessing(false);
        }
    }

    return (
        <>
            <TituloPagina titulo='Onboarding Stripe' subtitulo={new Date().toLocaleString('pt-BR')} />
            <Box sx={{ height: '70vh' }}>
                {
                    negocioDoUsuario === 0
                        ?
                        <Grid container style={{ paddingTop: 15, paddingBottom: 15 }} >
                            <Typography>Selecione o seu negócio no campo localizado no canto superior direito desta página.</Typography>
                        </Grid>
                        :
                        negocio.stripePayoutsEnabled
                            ?
                            <Grid container style={{ paddingTop: 15, paddingBottom: 15 }} >
                                <Typography>Parabéns! A integração da <strong>{negocio.nome}</strong> com nossa plataforma de pagamentos parceira, a Stripe, está ativa. Você já pode anunciar os seus produtos e receber pagamentos com segurança e transparência.</Typography>
                            </Grid>
                            :
                            <>
                                <Grid container style={{ paddingTop: 15, paddingBottom: 5 }} >
                                    <Typography>A sua loja no Passarela 44 ainda não está conectada à Stripe, que é a plataforma parceira responsável por processar os pagamentos das vendas. Para concluir essa etapa, clique no botão abaixo e gere um novo link de integração para a loja  <strong>{negocio.nome}</strong>. Esse link permite que a Stripe valide seus dados e habilite os pagamentos.</Typography>
                                </Grid>

                                <Grid container style={{ paddingTop: 5, paddingBottom: 25 }} >
                                    <Typography>Se tiver qualquer dúvida durante o processo, entre em contato pelo parcerias@passarela.com.br.</Typography>
                                </Grid>

                                <Grid container >
                                    <Button variant='contained' color='secondary' onClick={() => handleGerarUrlOnboardStripe()}>Gerar Link Stripe</Button>
                                </Grid>
                                {
                                    urlStripe
                                        ?
                                        <Grid container style={{ paddingTop: 30 }}>
                                            <Typography style={{ paddingBottom: 15 }}>Clique no link abaixo para realizar a integração da sua loja com a Stripe. O link também foi enviado para o seu e-mail.</Typography>
                                            <a href={`${urlStripe}`} target='_blank' rel='noopener noreferrer'>[{urlStripe}]</a>
                                        </Grid>
                                        :
                                        null
                                }
                            </>
                }
            </Box>

            {/* O componente Loading fica ouvindo o estado isProcessing */}
            <LoadingOverlay
                open={isProcessing}
                message={loadingMessage}
            />
        </>
    )
}

const mapStateToProps = state => (
    {
        negocioDoUsuario: state.negocio.negocioDoUsuario,
        negocio: state.negocio.negocio
    }
)

const mapDispatchToProps = dispatch => bindActionCreators(
    {
        getNegocio
    },
    dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(RegerarUrlStripe);